
export const onlyNumericalChars: RegExp = /^\d+$/;
